module.exports = __webpack_public_path__ + "img/white-check.49937945.svg";